var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          staticClass: "demo-form-inline",
          attrs: {
            inline: false,
            model: _vm.searchForm,
            "label-position": "top",
            size: "small",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "numberSearch", attrs: { label: "" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t(
                                  "CenterForSorting.pleaseChoose"
                                ),
                              },
                              model: {
                                value: _vm.type1,
                                callback: function ($$v) {
                                  _vm.type1 = $$v
                                },
                                expression: "type1",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("CenterForSorting.scanNumber"),
                                  value: "scanOrderNumberList",
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "CenterForSorting.waybillNumber"
                                  ),
                                  value: "waybillNumberList",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("InputTextareaCmp", {
                        ref: "inputTextareaRef",
                        staticStyle: { width: "100%" },
                        attrs: {
                          "max-length": 2000,
                          "min-rows": 2,
                          val: _vm.listVal,
                        },
                        on: {
                          input: function (_, val) {
                            return (_vm.listVal = val)
                          },
                        },
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CenterForSorting.machine") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "CenterForSorting.pleaseChoose"
                            ),
                            clearable: "",
                          },
                          on: { change: _vm.handleSearch },
                          model: {
                            value: _vm.searchForm.machineCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "machineCode", $$v)
                            },
                            expression: "searchForm.machineCode",
                          },
                        },
                        _vm._l(_vm.machineList, function (item) {
                          return _c("el-option", {
                            key: item.machineCode,
                            attrs: {
                              label:
                                item.machineName + "(" + item.machineCode + ")",
                              value: item.machineCode,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CenterForSorting.chuteNo") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("CenterForSorting.pleaseInput"),
                          clearable: "",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearch($event)
                          },
                        },
                        model: {
                          value: _vm.searchForm.chuteNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "chuteNumber", $$v)
                          },
                          expression: "searchForm.chuteNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CenterForSorting.bagNumber") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("CenterForSorting.pleaseInput"),
                          clearable: "",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearch($event)
                          },
                        },
                        model: {
                          value: _vm.searchForm.bagNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "bagNumber", $$v)
                          },
                          expression: "searchForm.bagNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CenterForSorting.uploadStatus") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "CenterForSorting.pleaseChoose"
                            ),
                            clearable: "",
                            multiple: "",
                          },
                          on: { change: _vm.handleStatusChange },
                          model: {
                            value: _vm.searchForm.statusList,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "statusList", $$v)
                            },
                            expression: "searchForm.statusList",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CenterForSorting.statusUploaded"),
                              value: 0,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CenterForSorting.statusBagged"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("CenterForSorting.statusCleaning"),
                              value: 2,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t(
                                "CenterForSorting.statusRemovedFromBag"
                              ),
                              value: 3,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 7 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CenterForSorting.timeRange") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "default-time": ["00:00:00", "23:59:59"],
                          "end-placeholder": _vm.$t("CenterForSorting.endTime"),
                          "picker-options": _vm.pickerOptions,
                          "start-placeholder": _vm.$t(
                            "CenterForSorting.startTime"
                          ),
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        on: {
                          focus: function ($event) {
                            _vm.pickDate = null
                          },
                        },
                        model: {
                          value: _vm.searchForm.createTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "createTime", $$v)
                          },
                          expression: "searchForm.createTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 9 } }, [
                _c(
                  "div",
                  { staticStyle: { "margin-top": "28px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          icon: "el-icon-search",
                          size: "mini",
                          type: "primary",
                        },
                        on: { click: _vm.handleSearch },
                      },
                      [_vm._v(_vm._s(_vm.$t("CenterForSorting.search")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-refresh", size: "mini" },
                        on: { click: _vm.resetSearch },
                      },
                      [_vm._v(_vm._s(_vm.$t("CenterForSorting.reset")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.allExportOrder },
                      },
                      [_vm._v(_vm._s(_vm.$t("collectionCenter.export")) + " ")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:sorting:uploadRecord:doBagging",
                      expression: "'btn:sorting:uploadRecord:doBagging'",
                      arg: "remove",
                    },
                  ],
                  attrs: { icon: "el-icon-box", size: "mini", type: "success" },
                  on: { click: _vm.handleBaggingClick },
                },
                [_vm._v(_vm._s(_vm.$t("CenterForSorting.doBagging")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:sorting:uploadRecord:clearData",
                      expression: "'btn:sorting:uploadRecord:clearData'",
                      arg: "remove",
                    },
                  ],
                  attrs: {
                    icon: "el-icon-delete",
                    size: "mini",
                    type: "warning",
                  },
                  on: { click: _vm.handleCleanClick },
                },
                [_vm._v(_vm._s(_vm.$t("CenterForSorting.clearData")) + " ")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.ind"),
                  align: "center",
                  type: "index",
                  width: "60",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.scanNumber"),
                  align: "center",
                  "min-width": "160",
                  prop: "scanOrderNumber",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.waybillNumber"),
                  align: "center",
                  "min-width": "160",
                  prop: "waybillNumber",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.scanGrid"),
                  align: "center",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.scanGrid
                          ? _vm._l(
                              String(row.scanGrid).split(","),
                              function (grid, index) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: index,
                                    staticStyle: {
                                      "margin-right": "4px",
                                      "margin-bottom": "4px",
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(grid) + " ")]
                                )
                              }
                            )
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.chuteNo"),
                  align: "center",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.chuteNumber
                          ? _vm._l(
                              String(row.chuteNumber).split(","),
                              function (chute, index) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: index,
                                    staticStyle: {
                                      "margin-right": "4px",
                                      "margin-bottom": "4px",
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(chute) + " ")]
                                )
                              }
                            )
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.machineCode"),
                  align: "center",
                  prop: "machineCode",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.supplyTable"),
                  align: "center",
                  width: "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getSupplyTableLabel(row))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.personAccount"),
                  align: "center",
                  prop: "personAccount",
                  width: "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.supplyTime"),
                  align: "center",
                  prop: "supplyTime",
                  width: "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.matchRule"),
                  align: "center",
                  "min-width": "120",
                  prop: "matchedRuleName",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.matchedRuleName
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleViewConditions(row)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(row.matchedRuleName) + " ")]
                            )
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.bagNumber"),
                  align: "center",
                  prop: "bagNumber",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.baggingType"),
                  align: "center",
                  prop: "baggingType",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.baggingType === 1
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CenterForSorting.normalBagging")
                                ) + " "
                              ),
                            ])
                          : row.baggingType === 2
                          ? _c("el-tag", { attrs: { type: "warning" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CenterForSorting.fallbackBagging")
                                ) + " "
                              ),
                            ])
                          : row.baggingType === 3
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CenterForSorting.abnormalBagging")
                                ) + " "
                              ),
                            ])
                          : _c("span", [_vm._v(_vm._s(row.baggingType))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.repeatBaggingCount"),
                  align: "center",
                  prop: "repeatBaggingCount",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.description"),
                  align: "center",
                  "min-width": "150",
                  prop: "description",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.weightWithUnit"),
                  align: "center",
                  prop: "weight",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.uploadStatus"),
                  align: "center",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                row.status === 1
                                  ? "success"
                                  : row.status === 2
                                  ? "warning"
                                  : row.status === 3
                                  ? "danger"
                                  : "primary",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  row.status === 1
                                    ? _vm.$t("CenterForSorting.statusBagged")
                                    : row.status === 2
                                    ? _vm.$t("CenterForSorting.statusCleaning")
                                    : row.status === 3
                                    ? _vm.$t(
                                        "CenterForSorting.statusRemovedFromBag"
                                      )
                                    : _vm.$t("CenterForSorting.statusUploaded")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.createTime"),
                  align: "center",
                  prop: "createTime",
                  width: "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("CenterForSorting.operation"),
                  align: "center",
                  fixed: "right",
                  width: "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: row.status === 2 || row.status === 3,
                              icon: "el-icon-remove-outline",
                              size: "mini",
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleRemoveFromBag(row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CenterForSorting.removeFromBag")) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  "current-page": _vm.listQuery.pageNumber,
                  "page-size": _vm.listQuery.pageSize,
                  "page-sizes": [10, 20, 50, 100],
                  total: _vm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.listQuery, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.listQuery, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.listQuery, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.listQuery, "pageSize", $event)
                  },
                  "current-change": _vm.fetchData,
                  "size-change": _vm.fetchData,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("CenterForSorting.baggingConfirm"),
            visible: _vm.baggingDialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.baggingDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "baggingForm",
              attrs: { model: _vm.baggingTemp, "label-position": "top" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CenterForSorting.machine"),
                    rules: [
                      {
                        required: true,
                        message: _vm.$t("CenterForSorting.pleaseChoose"),
                        trigger: "change",
                      },
                    ],
                    prop: "machineCode",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("CenterForSorting.pleaseChoose"),
                        filterable: "",
                      },
                      on: { change: _vm.handleBaggingMachineChange },
                      model: {
                        value: _vm.baggingTemp.machineCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.baggingTemp, "machineCode", $$v)
                        },
                        expression: "baggingTemp.machineCode",
                      },
                    },
                    _vm._l(_vm.machineList, function (item) {
                      return _c("el-option", {
                        key: item.machineCode,
                        attrs: {
                          label:
                            item.machineName + "(" + item.machineCode + ")",
                          value: item.machineCode,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CenterForSorting.chuteNo"),
                    rules: [
                      {
                        required: true,
                        message: _vm.$t("CenterForSorting.pleaseChoose"),
                        trigger: "change",
                      },
                    ],
                    prop: "chuteNumber",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("CenterForSorting.pleaseChoose"),
                        filterable: "",
                      },
                      on: { change: _vm.handleBaggingChuteChange },
                      model: {
                        value: _vm.baggingTemp.chuteNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.baggingTemp, "chuteNumber", $$v)
                        },
                        expression: "baggingTemp.chuteNumber",
                      },
                    },
                    _vm._l(_vm.chuteOptions, function (opt) {
                      return _c("el-option", {
                        key: opt.value,
                        attrs: { label: opt.label, value: opt.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CenterForSorting.bagNumber"),
                    rules: [
                      {
                        required: true,
                        message: _vm.$t("CenterForSorting.inputBagNumber"),
                        trigger: "blur",
                      },
                    ],
                    prop: "bagNumber",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("CenterForSorting.inputBagNumber"),
                    },
                    model: {
                      value: _vm.baggingTemp.bagNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.baggingTemp, "bagNumber", $$v)
                      },
                      expression: "baggingTemp.bagNumber",
                    },
                  }),
                ],
                1
              ),
              _vm.previewList.length > 0
                ? _c(
                    "div",
                    { staticClass: "preview-area" },
                    [
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CenterForSorting.previewPackage")) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.pagedPreviewList,
                            border: "",
                            height: "200",
                            size: "mini",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("CenterForSorting.scanNumber"),
                              prop: "scanOrderNumber",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var row = ref.row
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(row.scanOrderNumber)),
                                      ]),
                                      row.baggingType === 2 ||
                                      row.baggingType === 3
                                        ? _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                content:
                                                  row.baggingType === 2
                                                    ? _vm.$t(
                                                        "CenterForSorting.fallbackBagging"
                                                      )
                                                    : _vm.$t(
                                                        "CenterForSorting.abnormalBagging"
                                                      ),
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-warning",
                                                staticStyle: {
                                                  color: "#e6a23c",
                                                  "margin-left": "5px",
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1413457672
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("CenterForSorting.waybillNumber"),
                              prop: "waybillNumber",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.previewList.length > _vm.previewPageSize
                        ? _c("el-pagination", {
                            staticStyle: {
                              "text-align": "right",
                              "margin-top": "5px",
                            },
                            attrs: {
                              "current-page": _vm.previewPage,
                              "page-size": _vm.previewPageSize,
                              total: _vm.previewList.length,
                              layout: "prev, pager, next",
                              small: "",
                            },
                            on: {
                              "update:currentPage": function ($event) {
                                _vm.previewPage = $event
                              },
                              "update:current-page": function ($event) {
                                _vm.previewPage = $event
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.baggingDialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("CenterForSorting.cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.dialogBtnLoading, type: "primary" },
                  on: { click: _vm.confirmBagging },
                },
                [_vm._v(" " + _vm._s(_vm.$t("CenterForSorting.confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("CenterForSorting.clearData"),
            visible: _vm.cleanDialogVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.cleanDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "cleanForm",
              attrs: { model: _vm.cleanTemp, "label-position": "top" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CenterForSorting.machine"),
                    rules: [
                      {
                        required: true,
                        message: _vm.$t("CenterForSorting.pleaseChoose"),
                        trigger: "change",
                      },
                    ],
                    prop: "machineCode",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("CenterForSorting.pleaseChoose"),
                        filterable: "",
                      },
                      on: { change: _vm.handleCleanMachineChange },
                      model: {
                        value: _vm.cleanTemp.machineCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.cleanTemp, "machineCode", $$v)
                        },
                        expression: "cleanTemp.machineCode",
                      },
                    },
                    _vm._l(_vm.machineList, function (item) {
                      return _c("el-option", {
                        key: item.machineCode,
                        attrs: {
                          label:
                            item.machineName + "(" + item.machineCode + ")",
                          value: item.machineCode,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CenterForSorting.chuteNo"),
                    rules: [
                      {
                        required: true,
                        message: _vm.$t("CenterForSorting.pleaseChoose"),
                        trigger: "change",
                      },
                    ],
                    prop: "chuteNumber",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("CenterForSorting.pleaseChoose"),
                        filterable: "",
                      },
                      on: { change: _vm.handleCleanChuteChange },
                      model: {
                        value: _vm.cleanTemp.chuteNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.cleanTemp, "chuteNumber", $$v)
                        },
                        expression: "cleanTemp.chuteNumber",
                      },
                    },
                    _vm._l(_vm.chuteOptions, function (opt) {
                      return _c("el-option", {
                        key: opt.value,
                        attrs: { label: opt.label, value: opt.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.bagCountInfo
                ? _c(
                    "div",
                    {
                      staticClass: "info-area",
                      staticStyle: { "margin-top": "20px" },
                    },
                    [
                      _c("el-alert", {
                        attrs: {
                          closable: false,
                          title:
                            _vm.$t("CenterForSorting.bagCount") +
                            ": " +
                            _vm.bagCountInfo.bagCount,
                          "show-icon": "",
                          type: "info",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.cleanDialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("CenterForSorting.cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: !_vm.cleanTemp.chuteId,
                    loading: _vm.dialogBtnLoading,
                    type: "primary",
                  },
                  on: { click: _vm.confirmClean },
                },
                [_vm._v(" " + _vm._s(_vm.$t("CenterForSorting.confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("rule-condition-detail", {
        attrs: {
          "condition-configs": _vm.conditionConfigs,
          "rule-id": _vm.currentRuleId,
          visible: _vm.viewConditionsVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.viewConditionsVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }